/**
 * Canonical Q&A for the /faq page. Single source read by both FaqPage.jsx
 * (visible) and src/seo/structuredData.js (FAQPage JSON-LD), so the schema
 * always matches on-page text — the same pattern as solutionsContent.js.
 * Plain strings so visible text and schema text are byte-identical.
 */
export const faqPageFaq = [
  {
    q: 'Do customers get charged?',
    a: 'No. Deposits are secured without debiting or blocking funds.',
  },
  {
    q: 'Can I integrate with my tools?',
    a: 'Yes, connect via API, webhooks, or native PMS integrations.',
  },
  {
    q: 'Is it compliant?',
    a: 'We follow strict security standards and provide audit-ready records.',
  },
  {
    q: 'How long can I hold a deposit?',
    a: 'From a few hours up to several months, configurable per request.',
  },
]
